import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

interface Props {
  tableInfo?: ReactNode;
  disabled: boolean;
  refreshHandler: () => void;
  inviteAction: () => void;
  actionTitle: string;
}

const TableFooter = ({ tableInfo, disabled, refreshHandler, inviteAction, actionTitle }: Props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    footerAction: {
      color: disabled ? theme.customTypography.disabled.color : theme.customTypography.primary.color,
      cursor: disabled ? 'auto' : 'pointer'
    }
  }));

  const classes = useStyles(disabled);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {tableInfo}
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ mt: '18px', mr: '20px' }} onClick={disabled ? () => null : inviteAction}>
          <Typography data-testid="footer-actions-invite" className={classes.footerAction} variant="h4">
            {actionTitle}
          </Typography>
        </Box>
        <Box sx={{ mt: '18px' }} onClick={disabled ? () => null : refreshHandler}>
          <Typography data-testid="footer-actions-refresh" className={classes.footerAction} variant="h4">
            Refresh
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TableFooter;
